const bind = () => {
  $('[data-pl-article-pagination="input"]').on("mouseenter", function (e) {
    $(this).attr("placeholder", "nr");
  });
  $('[data-pl-article-pagination="input"]').on("mouseleave", function (e) {
    $(this).attr("placeholder", "\u2026");
  });

  const url = window.location.origin + window.location.pathname;
;

  $('[data-pl-article-pagination="input"]').on("focusin", function () {
    $(this).on("keypress", function (e) {
      if (e.key === "Enter") {
        window.location.replace(url + '?page=' + e.target.value);
      }
    });
  });

  $('[data-pl-article-pagination="input"]').on('focusout', function (e) {
        window.location.replace(url + '?page=' + e.target.value);
  });
};
export { bind };
